import React from 'react'
import { Flex, Box, Text, Link as ExternalLink } from 'rebass'
import { useTheme } from 'emotion-theming'
import { MediaQueries as Mq, styled } from '../../../styles/settings/theme'

import TargetLogo from '../../../assets/images/sponsor_logos/placeholder-logo.png'
import ChunkyLogo from '../../../assets/images/sponsor_logos/placeholder-logo.png'
import DoritosLogo from '../../../assets/images/sponsor_logos/placeholder-logo.png'
import UndeniablyDairyLogo from '../../../assets/images/sponsor_logos/placeholder-logo.png'
import Animation from '../../atoms/Animation'
import WideContainer from '../../atoms/WideContainer'
import WideContent from '../../atoms/WideContent'

const StyledBox = styled(Box)`
  h4 {
    text-align: left;
    padding-right: 1rem;
  }
`

const StyledFlex = styled(Flex)`
  padding: 3rem 0 5rem;
`

const RightBox = styled(Box)`
  text-align: left;
  margin-top: 1rem;
  margin-bottom: 2rem;

  &:nth-child(2) {
    img {
      margin-left: -1rem;
    }
  }

  ${Mq.md} {
    text-align: right;
    margin-top: 0rem;
    margin-bottom: 0rem;
    &:nth-child(2) {
      img {
        margin-left: inherit;
      }
    }
  }
`

const StyledWideContent = styled(WideContent)`
  background: ${props => props.theme.colors.white};
`

const DividerLine = styled(Box)`
  display: none;

  ${Mq.md} {
    display: block;
    width: 100%;
    margin-right: 2rem;
    border-bottom: 2px solid ${props => props.theme.colors.primarylightblueHighlight};
  }
`

const HomePageSponsors: React.FC = () => {
  const { colors } = useTheme()
  const animations = {
    hidden: {
      opacity: 0,
      x: '1.5rem',
    },
    hiddenLeft: {
      opacity: 0,
      x: '-1.5rem',
    },
    fade: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      x: 0,
    },
  }

  return (
    <StyledWideContent>
      <WideContainer>
        <StyledFlex
          width="auto"
          alignItems={['flex-start', 'flex-start', 'center']}
          flexDirection={['column', 'column', 'row']}
          pb={[4, 4, 6, 6]}
        >
          <StyledBox width="auto">
            <Animation
              initial="hiddenLeft"
              animate="visible"
              variants={animations}
              transition={{ ease: 'easeOut', duration: 0.4, delay: 0.6 }}
            >
              <Text color={colors.primarynavy}>
                <h4>brought to you by</h4>
              </Text>
            </Animation>
          </StyledBox>
          <DividerLine />
          <Box width="auto">
            <Flex
              width="auto"
              justifyContent={['flex-start', 'flex-start', 'flex-end']}
              mx={[-6, -6, -6, -4]}
              mt={[4, 4, 4, 0]}
            >
              <RightBox px={[6, 6, 6, 4]}>
                <Animation
                  initial="hidden"
                  animate="visible"
                  variants={animations}
                  transition={{ ease: 'easeOut', duration: 0.4, delay: 1 }}
                >
                  <ExternalLink
                    href="https://www.campbells.com/chunky/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={ChunkyLogo} alt="Chunky Logo" width="300px" height="auto" />
                  </ExternalLink>
                </Animation>
              </RightBox>
              <RightBox px={[6, 6, 6, 4]}>
                <Animation
                  initial="hidden"
                  animate="visible"
                  variants={animations}
                  transition={{ ease: 'easeOut', duration: 0.4, delay: 1 }}
                >
                  <ExternalLink
                    href="https://www.target.com/circle/o/madden-nfl-21/-/324434"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={TargetLogo} alt="Target Logo" width="300px" height="auto" />
                  </ExternalLink>
                </Animation>
              </RightBox>
              <RightBox px={[6, 6, 6, 4]}>
                <Animation
                  initial="hidden"
                  animate="visible"
                  variants={animations}
                  transition={{ ease: 'easeOut', duration: 0.4, delay: 1 }}
                >
                  <ExternalLink
                    href="https://www.discoverundeniablydairy.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={UndeniablyDairyLogo}
                      alt="Undeniably Dairy Logo"
                      width="230px"
                      height="auto"
                    />
                  </ExternalLink>
                </Animation>
              </RightBox>
              <RightBox px={[6, 6, 6, 4]}>
                <Animation
                  initial="hidden"
                  animate="visible"
                  variants={animations}
                  transition={{ ease: 'easeOut', duration: 0.4, delay: 1 }}
                >
                  <ExternalLink
                    href="https://www.doritos.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={DoritosLogo} alt="Doritos Logo" width="300px" height="auto" />
                  </ExternalLink>
                </Animation>
              </RightBox>
            </Flex>
          </Box>
        </StyledFlex>
      </WideContainer>
    </StyledWideContent>
  )
}

export default HomePageSponsors
